import React from "react";
import { Switch, Route, NavLink } from "react-router-dom";
import NotFound from "../NotFound";
import View from "./View";
import Create from "./Create";
import Edit from "./Edit";
import Reassign from "./Reassign";
import "./Appointment.css";
import AppointmentDashboard from "./Dashboard";
import YourAppointment from "./YourAppointment";
import AuthProvider from "../../providers/Auth.Provider";
import ActiveAppointment from "./ActiveAppointment";

const Appointment = () => {
    const { admin, topStaff } = AuthProvider.authProvider.GetAuthenticatedStaff();
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body text-center mt-4">
                            <NavLink exact className="mdl-button mdl-button--raised mdl-js-ripple-effect  margin-right-10" activeClassName="btn-success" to="/home/clinical-note/appointment">
                                <i className="material-icons">dashboard</i> Dashboard
                            </NavLink>
                            {!admin && !topStaff ? (
                                <button disabled={true} className="mdl-button mdl-button--raised mdl-js-ripple-effect disabled margin-right-10" type="button">
                                    <i className="material-icons">add</i> Active Appointment
                                </button>
                            ) : (
                                <NavLink className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10" activeClassName="btn-success" to="/home/clinical-note/appointment/active">
                                    <i className="material-icons">people_alt</i> Active Appointment
                                </NavLink>
                            )}
                            {!admin && !topStaff ? (
                                <button disabled={true} className="mdl-button mdl-button--raised mdl-js-ripple-effect disabled margin-right-10" type="button">
                                    <i className="material-icons">add</i> Create New Appointment
                                </button>
                            ) : (
                                <NavLink className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10" activeClassName="btn-success" to="/home/clinical-note/appointment/create">
                                    <i className="material-icons">control_point</i> Create New Appointment
                                </NavLink>
                            )}

                            {!admin && !topStaff ? (
                                <button className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 disabled" disabled={true} type="button">
                                    <i className="material-icons">calendar_view_day</i> Manage Appointment
                                </button>
                            ) : (
                                <NavLink className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10" activeClassName="btn-success" to="/home/clinical-note/appointment/list">
                                    <i className="material-icons">calendar_view_day</i> Manage Appointment
                                </NavLink>
                            )}

                            <NavLink className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10" activeClassName="btn-success" to="/home/clinical-note/appointment/your-appointment">
                                <i className="material-icons">person_pin</i> Your Appointment
                            </NavLink>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <Switch>
                        <Route exact path="/home/clinical-note/appointment" component={AppointmentDashboard} />
                        <Route exact path="/home/clinical-note/appointment/list" component={View} />
                        <Route path="/home/clinical-note/appointment/create" component={Create} />
                        <Route path="/home/clinical-note/appointment/edit" component={Edit} />
                        <Route path="/home/clinical-note/appointment/reassign" component={Reassign} />
                        <Route path="/home/clinical-note/appointment/your-appointment" component={YourAppointment} />
                        <Route path="/home/clinical-note/appointment/active" component={ActiveAppointment} />
                        <Route component={NotFound} />
                    </Switch>
                </div>
            </div>
        </>
    );
};

export default Appointment;
